import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as rolesAndPermissionsAPI from 'api/Settings/rolesAndPermissions';
import { TYPE_OF_FIELD_IN_COLUMN } from 'utils/scorecard';
// import { getRolesDataAction, setPageSizeAction, setCurrentPageAction } from 'hooks/Setting/useSetting';

const initalState = {
  roles: {
    pageSize: 10,
    currentPage: 1,
    data: null,
    totalRecords: 0,
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      // { title: '#', key: 'id', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Role Name', key: 'name', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Level', key: 'level', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init'
  },
  permissions: {
    data: null,
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      { title: 'Lob', key: 'Lob', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init'
  }
};

const getRolesData = createAsyncThunk('settings/roles', async (filter) => {
  const res = await rolesAndPermissionsAPI.getRoles(filter);
  return res.data?.data;
});

const createRole = createAsyncThunk('settings/addrole', async (params) => {
  const res = await rolesAndPermissionsAPI.createRole(params);
  return res.data?.data;
});

const updateRole = createAsyncThunk('settings/updaterole', async (params) => {
  const res = await rolesAndPermissionsAPI.updateRole(params);
  return res.data?.data;
});

const deleteRole = createAsyncThunk('settings/deleterole', async (id) => {
  const res = await rolesAndPermissionsAPI.deleteRole(id);
  return res.data?.data;
});

const getPermissionsData = createAsyncThunk('settings/permissions', async (filter) => {
  const res = await rolesAndPermissionsAPI.getPermissionsData(filter);
  return res.data?.data;
});

const updatePermissionsData = createAsyncThunk('settings/updatepermissions', async (params) => {
  const res = await rolesAndPermissionsAPI.updatePermissionsData(params);
  return res.data?.data;
});

const rolesAndPermissionSlice = createSlice({
  name: 'rolesAndPermissions',
  initialState: initalState,

  reducers: {
    resetState: () => {
      return initalState;
    },
    setCurrentPage: (state, action) => {
      state.roles.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.roles.pageSize = action.payload;
    },
    setPermissionStatusChange: (state, action) => {
      const id = action.payload;
      const index = state.permissions.data.findIndex((item) => item.id === id);
      if (index !== -1) {
        const status = state.permissions.data[index].status;
        state.permissions.data[index].status = !status;
      }
    }
  },
  extraReducers: {
    [getRolesData.pending]: (state) => {
      state.roles.status = 'init';
      state.roles.ui.loading = true;
    },

    [getRolesData.fulfilled]: (state, action) => {
      console.log('roleaction', action.payload);
      state.roles.status = 'idle';
      state.roles.ui.loading = false;
      state.roles.data = action.payload.results;
      state.roles.totalRecords = action.payload.count;
    },

    [getRolesData.rejected]: (state, action) => {
      state.roles.status = 'error';
      state.roles.error = action.error.message;
      state.roles.ui.loading = false;
    },

    [createRole.pending]: (state) => {
      state.roles.status = 'init';
      state.roles.ui.loading = true;
    },

    [createRole.fulfilled]: (state) => {
      state.roles.status = 'idle';
      state.roles.ui.loading = false;
      //state.roles.data = [...state.roles.data, action.payload];
    },

    [createRole.rejected]: (state, action) => {
      state.roles.status = 'error';
      state.roles.error = action.error.message;
      state.roles.ui.loading = false;
    },

    [updateRole.pending]: (state) => {
      state.roles.status = 'init';
      state.roles.ui.loading = true;
    },

    [updateRole.fulfilled]: (state, action) => {
      state.roles.status = 'idle';
      state.roles.ui.loading = false;
      const updatedData = state.roles.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.roles.data = updatedData;
    },

    [updateRole.rejected]: (state, action) => {
      state.roles.status = 'error';
      state.roles.error = action.error.message;
      state.roles.ui.loading = false;
    },

    [deleteRole.pending]: (state) => {
      state.roles.status = 'init';
      state.roles.ui.loading = true;
    },

    [deleteRole.fulfilled]: (state) => {
      state.roles.status = 'idle';
      state.roles.ui.loading = false;
      // const updatedData = state.roles.data.filter((item) => item.id !== action.payload.id);
      // state.roles.data = updatedData;
    },

    [deleteRole.rejected]: (state, action) => {
      state.roles.status = 'error';
      state.roles.error = action.error.message;
      state.roles.ui.loading = false;
    },

    [getPermissionsData.pending]: (state) => {
      state.permissions.status = 'init';
      state.permissions.ui.loading = true;
    },

    [getPermissionsData.fulfilled]: (state, action) => {
      state.permissions.status = 'idle';
      state.permissions.ui.loading = false;
      state.permissions.data = action.payload;
    },

    [getPermissionsData.rejected]: (state, action) => {
      state.permissions.status = 'error';
      state.permissions.error = action.error.message;
      state.permissions.ui.loading = false;
    },

    [updatePermissionsData.pending]: (state) => {
      state.permissions.status = 'init';
      state.permissions.ui.loading = true;
    },

    [updatePermissionsData.fulfilled]: (state) => {
      state.permissions.status = 'idle';
      state.permissions.ui.loading = false;
    },

    [updatePermissionsData.rejected]: (state, action) => {
      state.permissions.status = 'error';
      state.permissions.error = action.error.message;
      state.permissions.ui.loading = false;
    }
  }
});

export const { setCurrentPage, setPageSize, setPermissionStatusChange } = rolesAndPermissionSlice.actions;

export default rolesAndPermissionSlice.reducer;

export { getRolesData, getPermissionsData, createRole, updateRole, deleteRole, updatePermissionsData };
